<div class="flex justify-between items-end">
  <div class="flex flex-row-reverse justify-end items-end" style="margin-inline-start: 1rem;">
    <div *ngIf="extraCount > 0" class="text-2xl">
      <h1>...</h1>
    </div>
    <!-- <div *ngIf="recipients?.length > 0" style="font-size: 0.8rem; background: #eee; color: #333; padding: 0.5rem;">
      <div *ngFor="let r of recipients; let i = index">
        [{{ i }}] {{ r.friendlyName }} ({{ r.userStatus }})
      </div>
    </div> -->
    <div *ngFor="let user of displayedRecipients; let i = index"
      [ngClass]="getCircleClasses(user.userStatus.toString() , i)" [matTooltip]="user.friendlyName"
      matTooltipClass="new-lines" matTooltipPosition="below">
      <div *ngIf="isEmail(user.friendlyName)">
        <i class="fa-regular fa-at text-xl"></i>
      </div>
      <div *ngIf="isPhone(user.friendlyName)">
        <i class="fa-regular fa-comment-sms text-2xl text-center "></i>
      </div>
      <div *ngIf="isWhatsApp(user.friendlyName)">
        <i class="fa-brands fa-whatsapp text-2xl text-center"></i>
      </div>
      <div *ngIf="!isEmail(user.friendlyName) && !isPhone(user.friendlyName) && !isWhatsApp(user.friendlyName)">
        <!-- <span>{{ initials(user.friendlyName) }}</span> -->
        <ng-container
          *ngIf="user.friendlyName && user.friendlyName !== '-' && user.friendlyName.trim().length > 0; else unknownIcon">
          <span>{{ initials(user.friendlyName) }}</span>
        </ng-container>
        <ng-template #unknownIcon>
          <i class="fa-solid fa-question text-xl"></i>
        </ng-template>
      </div>
    </div>

  </div>
</div>